var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('date-picker',{staticClass:"arvio-datepicker",attrs:{"value":_vm.value,"format":"DD.MM.YYYY","value-type":"timestamp"},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }